






import { Component, InjectReactive, Vue } from 'vue-property-decorator';

import { FeedProduct } from '../../models';
import SMSCharges from '@/components/smsCharges/smsCharges.vue';

@Component({
	components: {
		SMSCharges,
	},
})
export default class FeedProductSMSChargesJobsTab extends Vue {
	@InjectReactive('feedProduct')
	public feedProduct!: FeedProduct;
}
